import { startOfWeek, addDays, format, parseISO } from "date-fns";
import { it } from "date-fns/locale";

export const DAY_NAMES = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];
export const DAY_SHORT = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];

export const mondayOf = (d) => startOfWeek(d, { weekStartsOn: 1 });
export const iso = (d) => format(d, "yyyy-MM-dd");
export const todayIso = () => iso(new Date());

export const weekDays = (monday) =>
  DAY_NAMES.map((name, idx) => {
    const d = addDays(monday, idx);
    return { idx, name, short: DAY_SHORT[idx], iso: iso(d), label: format(d, "d MMM", { locale: it }) };
  });

export const weekLabel = (monday) =>
  `${format(monday, "d MMM", { locale: it })} – ${format(addDays(monday, 5), "d MMM yyyy", { locale: it })}`;

export const prettyDate = (isoStr) => format(parseISO(isoStr), "EEE d MMM", { locale: it });

export const isOverdue = (t) => !t.completed && !!t.date && t.date < todayIso();

export const todayIdx = () => {
  const wd = new Date().getDay();
  return wd >= 1 && wd <= 6 ? String(wd - 1) : "all";
};
